////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import { isNull } from 'lodash'
import moment from 'moment'
///////COMPONENTS///////
import TableNested from '../../../components/Table/components/TableNested'
import { KioskPricesManagerCampaignStatus, KioskPricesManagerTransmitStatus } from '.'
//import ActionsTable from '../../ScheduledPromoManager/ActionsTable'
import ActionsTable from '../../../components/ActionsTable'
import userPrivileges from '../../../constants/PrivilegesList'
/////////ASSETS/////////
import ArrowLeft from '../../../assets/icones/global/arrow-left.svg'
import ArrowRight from '../../../assets/icones/global/arrow-right.svg'
import ArrowLeftGrey from '../../../assets/icones/global/arrow-left-grey.svg'
import ArrowRightGrey from '../../../assets/icones/global/arrow-right-grey.svg'
import editPriceCampaignIcon from '../../../assets/icones/global/edit-blue.svg'

//////STYLED//////
const KioskPricesManagerNestedWrapper = styled.td`
	display:${(props) => (props.isVisible ? 'table-cell' : 'none')};
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
	& > div{
		max-width: calc(100% - 200px);
		overflow-x: scroll;
		margin: auto;
		position: relative;

		&::-webkit-scrollbar {
			width: 50px;
			background-color: rgba(0,0,0,.15);
			height: 15px;
		}
		&::-webkit-scrollbar-thumb {
			background: #4D4F5C; 
			height:100%;
		}
		&::-webkit-scrollbar-thumb:active {
			background rgba(77, 79, 92, 0.7); 
			height:100%;
		}
		&::-webkit-scrollbar-button:horizontal:decrement:single-button {
			background: no-repeat center url(${ArrowLeft});
			height:9px;
			width:15px;
			margin-bottom:1px;
		}
		&::-webkit-scrollbar-button:horizontal:increment:single-button {
			background: no-repeat center url(${ArrowRight});
			height:9px;
			width:15px;
			padding-bottom:10%;
		}
		&::-webkit-scrollbar-button:horizontal:decrement:single-button:active {
			background: no-repeat center url(${ArrowLeftGrey});
			height:9px;
			width:15px;
			margin-bottom:1px;
		}
		&::-webkit-scrollbar-button:horizontal:increment:single-button:active {
			background: no-repeat center url(${ArrowRightGrey});
			height:9px;
			width:15px;
			padding-bottom:10%;
		}
	
		/* scrollbar styling standard version */
		& {
		  scrollbar-color: #4D4F5C #E5E5E5;
		  scrollbar-width: thin;
		}
	}
	& > div:before{
		content:'';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -1px;
		box-shadow: 3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div:after{
		content:'';
		height: 100%;
		width: 1px;
		position: absolute;
		right: -1px;
		box-shadow: -3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div > div{
		min-width: max-content;
	}
	& > div > div > div > form { 
		overflow: hidden;
		width: 100%;
	}
`
//////STYLED//////

const KioskPricesManagerNested = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: '',
		isInNestedTable: true,
	}

	const columns = [
		{
			dataHook: 'campaignStatus',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_priceCampaignStatus'],
			sortable: true,
			isAuthorize: true,
			component: KioskPricesManagerCampaignStatus,
		},
		{
			dataHook: 'campaignMode.translationKey',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_typeOfModify'],
			sortable: true,
			toTranslate: true,
			isAuthorize: true,
		},
		{
			dataHook: 'campaignName',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_name'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'campagainDateStart',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_dateStartPriceCampaign'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.campagainDateStart) ? moment(props.row.campagainDateStart).format('DD/MM/YYYY HH:mm') : '-'),
		},
		{
			dataHook: 'promoDateEnd',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_dateEndPriceCampaign'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.promoDateEnd) ? moment(props.row.promoDateEnd).format('DD/MM/YYYY HH:mm') : '-'),
		},
		{
			dataHook: 'currency.symbol',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_currency'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'priceItem',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_standardPriceInCampaign'],
			sortable: true,
			isAuthorize: true,
			component: (props) => `${props.row.priceItem}${props.row.currency.symbol}`,
		},
		{
			dataHook: 'priceDeposit',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_depositPriceInCampaign'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.priceDeposit) ? `${props.row.priceDeposit}${props.row.currency.symbol}` : '-'),
		},
		{
			dataHook: 'totransmitStatus',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_transmitStatus'],
			sortable: true,
			isAuthorize: true,
			component: KioskPricesManagerTransmitStatus,
		},
		{
			dataHook: 'dateLastToTransmit',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_dateLastTransmit'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.dateLastToTransmit) ? moment(props.row.dateLastToTransmit).format('DD/MM/YYYY HH:mm') : '-'),
		},
		{
			dataHook: 'remaningAllocatedStock',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_remainingAllocatedStock'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'promoCode',
			headerName: translations['page__pricesManagement__pricesByKiosk__admin__pricesTable_expand_tableHeader_promoCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			action: true,
			isFixed: true,
			component: ActionsTable,
			withIcons: false,
			rest: {
				paperActionsList: [
					{
						//icon: editPriceCampaignIcon,
						name: translations['tooltip__admin__priceManagement__updatePriceOrPromoCampaign'],
						clickAction: (row) => {
							props.setRow(row)
						},
						// isVisible: row => ((row.promotionStatus.subFlow !== "100") && (row.promotionStatus.subFlow !== '999'))
						isVisible: (row) => true,
						tooltip: {
							translationsKey: 'tooltip__admin__priceManagement__updatePriceOrPromoCampaign',
							tooltipId: 'priceNestedUpdateCampaign',
						},
					},
				],
			},
			checkRight: userPrivileges.action[2],
		},
	]

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<KioskPricesManagerNestedWrapper colSpan={props.colspan} isVisible={props.stateToggleNested}>
			<div>
				<div>
					<TableNested inputColumns={columns} inputData={props.row.pricesLine} inputConfig={config} />
				</div>
			</div>
		</KioskPricesManagerNestedWrapper>
	)
}

KioskPricesManagerNested.propTypes = {}

KioskPricesManagerNested.defaultPropTypes = {}

export default KioskPricesManagerNested
